export class Customer {

    id = ""
    name = ""
    url = ""
    /** @type {Date|null} **/
    lastInvoiceAt = null;
    hourlyRate = 0;
    hoursPerWeek = 0;
    workspaceId = "";
    folderName = "";

    constructor(data={}) {
        Object.assign(this, data);
    }
}